import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component, Input, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SpinnerService } from '../../services/spinner.service';


const animationTime = 500;

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  animations: [
    trigger('showHide', [
      state(
        'show',
        style({
          opacity: 1,
        })
      ),
      state(
        'hide',
        style({
          opacity: 0,
        })
      ),
      transition('show => hide', [animate(`${animationTime}ms`)]),
      transition('hide => show', [animate(`${animationTime}ms`)]),
    ]),
  ],
})
export class LoadingComponent implements OnDestroy {
  @Input() height = '100px';

  loading$!: Observable<boolean>;
  private _unsubscribeAll$ = new Subject<void>();

  constructor(spinnerService: SpinnerService) {
    this.loading$ = spinnerService.isShowingSpinner$();

  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }
}
